
export type AppointmentRow = {
  id: string;
  date: string;
  time: string;
  status: string;
  provider: string;
  joinUrl?: string;
  endDateTime?: string;
};

export const consultationsColumns = [
  { label: "Appointment ID", accessor: "id" },
  { label: "Date", accessor: "date" },
  { label: "Time", accessor: "time" },
  { label: "Status", accessor: "status" },
  { label: "Provider", accessor: "provider" },
] as const;
